// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"877d6581","453":"77c62747","455":"43c034bf"}[chunkId] + ".chunk.js";
};